import { z } from "zod";

export const CategoryUploadSchema = z.object({
  file: z.any().default(null),
});
